import React, { useState, useEffect , useRef } from 'react';
import axios from 'axios';
import {
  Grid,
  Button
} from "@mui/material";
import {useReactToPrint} from "react-to-print";
import Topbar from "../global/Topbar";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

function InternalDeptMaster(props) {
  const [rooms, setRooms] = useState([]);
  const [IDeptCode, setIDeptCode] = useState('');
  const [IDeptName, setIDeptName] = useState('');
  const [IDeptNameENG, setIDeptNameENG] = useState('');
  
  const [errorMessage, setErrorMessage] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  
  const [formMode, setFormMode] = useState('add');
  const [editRoomId, setEditRoomId] = useState(null);
  const [showGrid, setShowGrid] = useState(true);
  const [deptMasterEntries, setDeptMasterEntries] = useState([]);
  const [ideptMasterEntries, setIDeptMasterEntries] = useState([]);

  const [deleteEntryNo, setDeleteEntryNo] = useState(null);
  const [openConfirmation, setOpenConfirmation] = useState(false);  

  useEffect(() => {
    //fetchDeptMaster();
    fetchIDeptMaster();
  }, []);


/*   const fetchDeptMaster = async () =>{
    try{
      const response = await axios.get('https://www.wingap.net.in/api/items');
      setDeptMasterEntries(response.data);
    }catch(error){
      console.log('error:', error);
    }
  }; */

  const fetchIDeptMaster = async () =>{
    try{
      const response = await axios.get('https://www.wingap.net.in/api/internalDept');
      setIDeptMasterEntries(response.data);
      const maxEntryNo = calculateMaxEntryNo(response.data);
      const nextEntryNo = maxEntryNo + 1;
      setIDeptCode(nextEntryNo)
    //   console.log(response);
    }catch(error){
      console.log('error:', error);
    }
  };

  const calculateMaxEntryNo = (entries) => {
    let maxEntryNo = 0;
    for (const entry of entries) {
      if (entry.IDeptCode > maxEntryNo) {
        maxEntryNo = entry.IDeptCode;
      }
    }
    return maxEntryNo;
  };

  const addMaster = async () => {
    try {
      await axios.post('https://www.wingap.net.in/api/internalDept', {
        IDeptCode: IDeptCode,
        IDeptName: IDeptName,
        IDeptNameENG: IDeptNameENG,
        USERID: props.name
      });
      fetchIDeptMaster();
      setIDeptCode('');
      setIDeptName('');
      setIDeptNameENG('');
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const updateRoom = async (IDeptCode) => {
    try {
      await axios.put(`https://www.wingap.net.in/api/internalDept/${IDeptCode}`, {
        IDeptCode: IDeptCode,
        IDeptName: IDeptName,
        IDeptNameENG: IDeptNameENG,
        USERID: props.name
      });
      fetchIDeptMaster();
      setIDeptCode('');
      setIDeptName('');
      setIDeptNameENG('');
      setFormMode('add');
    } catch (error) {
      console.log('Error:', error);
    }
  };
  
  
  const handleDeleteConfirmation = async () => {
    try {
      if (deleteEntryNo) {
        await deleteRoom(deleteEntryNo.DeptCode);
        setOpenConfirmation(false);
      }
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const deleteRoom = async (IDeptCode) => {
    try {
      const response = await axios.delete(`https://www.wingap.net.in/api/internalDept/${IDeptCode}`, {
        headers: {
          'username': props.name,
        },
      });
      if (response.status === 200) {
        fetchIDeptMaster();
      }
    } catch (error) {
      console.log('Error:', error);

      if (error.response && error.response.status === 403) {
        // User does not have permission to delete account group
        setErrorMessage('Permission Denied');
        setSnackbarOpen(true);
      } else {
        // Handle other errors if needed
        setErrorMessage('An error occurred while deleting the account group. Please try again later.');
        setSnackbarOpen(true);
        // Alternatively, you can log the detailed error to the console for debugging
        console.error('Error:', error);
      }
    }
  };

  const handleCloseSnackbar = () => {
    // Close the Snackbar
    setSnackbarOpen(false);
    // Reset the error message
    setErrorMessage('');
  }; 

  const setEditForm = (room) => {
    setFormMode('edit');
    setIDeptCode(room.IDeptCode);
    setIDeptName(room.IDeptName);
    setIDeptNameENG(room.IDeptNameEng);
    setShowGrid(false);
  };

 
  const handleSearch = (searchQuery) => {
    const filtered = rooms.filter((room) => {
      // Convert room.RoomNo, room.IDeptName, etc., to strings before using includes
      const IDeptCode = room.DeptCode.toString().toLowerCase();
      const IDeptName = room.IDeptName.toString().toLowerCase();
      const IDeptNameENG = room.IDeptNameENG.toString().toLowerCase();
      const compCode = room.compCode.toString().toLowerCase();
      const flag = room.flag.toString().toLowerCase();

      // Check if any of the properties contain the searchQuery (converted to lowercase)
      return (
        IDeptCode.includes(searchQuery.toLowerCase()) ||
        IDeptName.includes(searchQuery.toLowerCase()) ||
        IDeptNameENG.includes(searchQuery.toLowerCase()) ||
        compCode.includes(searchQuery.toLowerCase()) ||
        flag.includes(searchQuery.toLowerCase())
      );
    });

    // Update the deptMasterEntries state with the filtered results
    setDeptMasterEntries(filtered);
  };

  // ... Rest of your code ...

  // Update the filtered rooms based on the searchQuery prop
  useEffect(() => {
    handleSearch(props.searchQuery);
  }, [props.searchQuery, rooms]);

  const handleshowandhide = () => {
    setShowGrid(!showGrid);
    setRooms(rooms);
    setIDeptName('');
    setIDeptNameENG('');
  }

  const handleCancel = () => {
    setFormMode('add');
    setEditRoomId('');
    setIDeptName('');
    setIDeptNameENG('');
  };

   
  const componentPDF= useRef();

  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    documentTitle: "BookingData",
    onAfterPrint: () => alert("Pdf downloaded"),
    pageStyle: `
      @media print {
        .print-hide {
          display: none;
        }
        
        table th.print-hide,
        table td.print-hide {
          border: none;
        }
      }
    `,
  });

  return (
    <div style={{ maxWidth: '100%', margin: '0 auto',padding: '20px' }} >
      <h1 style={{ fontSize: '24px', marginBottom: '10px' }}>InternalDeptMaster</h1>
      <Grid item>
          <Button
            variant="contained"
            className="view-button"
            onClick={handleshowandhide}
            sx={{ backgroundColor: showGrid ? '#4caf50' : 'blue', color: "white", marginBottom: "20px", float:'right'}}
          >
            {showGrid ? 'Add' : 'Back'}
          </Button>
        </Grid>
        {showGrid && <Grid item>
          <Button
            variant="contained"
            onClick={generatePDF}
            sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float:'right', marginRight:"10px"}}
          >
            Download PDF
          </Button>
        </Grid>}
        {showGrid && <Grid item>
          <Button
            variant="contained"
            // onClick={generatePDF}
            sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float:'right', marginRight:"10px"}}
          >
            Export
          </Button>
        </Grid>}
        {!showGrid && (
           <>
           <h2 style={{ fontSize: '20px', marginBottom: '10px' }}>{formMode === 'add' ? 'Add' : 'Edit'}</h2>
           <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px' }}>
             <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
               <label htmlFor="IDeptCode" style={{ width: '150px', marginRight: '10px' }}>IDeptCode</label>
               <input
                 type="text"
                 value={IDeptCode}
                 readOnly
                 placeholder="IDeptCode"
                 style={{ marginBottom: '5px', padding: '5px', width: '9%' }}
               />
             </div>
             <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
               <label htmlFor="IDeptName" style={{ width: '150px', marginRight: '10px' }}>IDeptName</label>
               <input
                 type="text"
                 value={IDeptName}
                 onChange={(e) => setIDeptName(e.target.value)}
                 placeholder="IDeptName"
                 style={{ marginBottom: '5px', padding: '5px', width: '40%' }}
                 list="deptNames"
               />
             </div>
             <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
               <label htmlFor="IDeptNameENG" style={{ width: '150px', marginRight: '10px' }}>IDeptNameENG</label>
               <input
                 type="text"
                 value={IDeptNameENG}
                 onChange={(e) => setIDeptNameENG(e.target.value)}
                 placeholder="IDeptNameENG"
                 style={{ marginBottom: '5px', padding: '5px', width: '40%' }}
               />
             </div>
             {/* <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
              <label htmlFor="compCode" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>Company Code</label>
              <input
                type="number"
                value={compCode}
                onChange={(e) => setCompCode(e.target.value)}
                onInput={(e) => {
                  const enteredAcCode = parseInt(e.target.value, 10);
                  setCompCode(enteredAcCode);
                  const selectedGroup = compMasterEntries.find(group => group.CompCode === enteredAcCode);
                  if (selectedGroup) {
                    setCompName(selectedGroup.CompName);
                  } else {
                    setCompName('');
                  }
                }}
                placeholder="CompCode"
                style={{ marginBottom: '5px', padding: '5px', width: '9%' }}
              />
              <select
                  value={compName}
                  onChange={(e) => {
                    const selectedGroupName = e.target.value;
                    setCompName(selectedGroupName);
                    const selectedGroup = compMasterEntries.find(group => group.CompName === selectedGroupName);
                    if (selectedGroup) {
                      setCompCode(selectedGroup.CompCode);
                    }
                  }}
                  style={{ marginBottom: '5px', marginLeft:'10px' ,padding: '5px', width: '30%' }}
                >{
                  compMasterEntries.map((group) => (
                      <option key={group.compCode} value={group.CompName}>{group.CompName}</option>
                    ))
                  }</select>
            </div> */}
          </div>
           <div>
             <button
               className={formMode === 'add' ? 'add-button' : 'update-button'}
               onClick={formMode === 'add' ? addMaster : () => updateRoom(IDeptCode)}
               style={{
                 padding: '10px 20px',
                 fontSize: '16px',
                 backgroundColor: formMode === 'add' ? '#4caf50' : '#2196f3',
                 color: 'white',
                 border: 'none',
                 cursor: 'pointer',
                 marginBottom: '10px',
               }}
             >
               {formMode === 'add' ? 'Add' : 'Update'}
             </button>
             <button
               className="view-button"
               onClick={handleCancel}
               style={{
                 padding: '10px 20px',
                 fontSize: '16px',
                 backgroundColor: '#f44336',
                 color: 'white',
                 border: 'none',
                 cursor: 'pointer',
                 marginLeft: '10px',
                 marginBottom: '10px',
               }}
             >
               Cancel
             </button>
           </div>
         </>
         
          )}
        {showGrid && (
            <div ref={componentPDF} style={{width:'100%'}}>
              <h2>Entries</h2>
              <table
                style={{
                  width: '100%',
                  borderCollapse: 'collapse',
                  border: '1px solid #ccc',
                }}
              >
                <thead>
                  <tr style={{ background: '#f2f2f2', color:'black' }}>
                    <th
                      style={{
                        padding: '8px',
                        background: '#f2f2f2',
                        border: '1px solid #ccc',
                      }}
                    >
                      IDeptCode
                    </th>
                    <th
                      style={{
                        padding: '8px',
                        background: '#f2f2f2',
                        border: '1px solid #ccc',
                      }}
                    >
                      IDeptName
                    </th>
                    <th
                      style={{
                        padding: '8px',
                        background: '#f2f2f2',
                        border: '1px solid #ccc',
                      }}
                    >
                      IDeptNameENG
                    </th>
                    <th
                      style={{
                        padding: '8px',
                        background: '#f2f2f2',
                        border: '1px solid #ccc',
                      }}
                    >
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {ideptMasterEntries.map((room) => (
                    <tr key={room.IDeptCode} style={{backgroundColor:'white', color:'black', textAlign:'center'}}>
                      <td style={{ padding: '8px', border: '1px solid #ccc' }}>{room.IDeptCode}</td>
                      <td style={{ padding: '8px', border: '1px solid #ccc' }}>{room.IDeptName}</td>
                      <td style={{ padding: '8px', border: '1px solid #ccc' }}>{room.IDeptNameEng}</td>
                      <td className="print-hide" >
                        <button
                          style={{
                            padding: '5px 10px',
                            backgroundColor: 'rgb(76, 175, 80)',
                            color: 'white',
                            border: 'none',
                            cursor: 'pointer',
                            marginRight: '5px',
                            marginLeft:'10px',
                          }}
                          onClick={() => setEditForm(room)}
                        >
                          Edit
                        </button>
                        <button
                          style={{
                            padding: '5px 10px',
                            backgroundColor: 'rgb(244, 67, 54)',
                            color: 'white',
                            border: 'none',
                            cursor: 'pointer',
                          }}
                          onClick={() => {
                            setDeleteEntryNo({DeptCode: room.IDeptCode});
                            setOpenConfirmation(true); 
                          }}
                          >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

      {/* Snackbar for displaying error messages */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'center', horizontal: 'center'}} // Center the Snackbar
      >
        <MuiAlert elevation={6} variant="filled" severity="error" sx={{fontSize:'16px'}} onClose={handleCloseSnackbar}>
          {errorMessage}
        </MuiAlert>
      </Snackbar>

      <Dialog
            open={openConfirmation}
            onClose={() => setOpenConfirmation(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{"Confirm Delete"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Are you sure you want to DELETE ?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenConfirmation(false)} color="inherit">
                Cancel
              </Button>
              <Button onClick={() => handleDeleteConfirmation()} color="error" autoFocus>
                DELETE
              </Button>
            </DialogActions>
          </Dialog>
    </div>
  );
}

export default InternalDeptMaster;